import { useQuery } from 'react-query'
import AddressType from '../../types/shared/AddressType'
import { apiGetData } from '../../core/utils/api/generic'

export default () => useQuery(['company-ad'], () => apiGetData<AddressType[]>('/addresses/company'))
